import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import BarChartComponent from "./BarChartComponent";
import { getConfig, searchAPI } from "../../../apis";
import { useSelector } from "react-redux";
import CustomLoader from "../../../components/loader";
import {
  ITEMS_PER_PAGE,
  frequencies,
  metrics,
  sortOptions,
} from "../../../constants";
import DateComponent from "../../../components/DateComponent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import MenuPrimary from "../../../components/menu/MenuPrimary";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { axiosInstance } from "../../../functions/axios";

const PopupInfoDiet = (props) => {
  const isMobile = useIsMobile();
  const { showInfoDietPopup, setShowInfoDietPopup } = props;
  const [metricFilter, setMetricFilter] = useState(JSON.stringify(metrics[0]));
  const [frequencyFilter, setFrequencyFilter] = useState(
    JSON.stringify(frequencies[0])
  );
  const [page, setPage] = useState(1);
  const [analyticsData, setAnalyticsData] = useState({});

  const [labels, setLabels] = useState({});
  const [metricCounts, setMetricCounts] = useState({});
  const [allData, setAllData] = useState([]);

  const [loading, setLoading] = useState(true);

  const { user } = useSelector((state) => state.auth);
  const [datepicker, setDatepicker] = useState(false);
  const [sort, setSort] = useState(false);
  const [unratedMetric, setUnratedMetric] = useState(0);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [maxVal, setMaxVal] = useState(0);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });
  const [sortVal, setSortVal] = useState(sortOptions[0]);

  const getData = async () => {
    setLoading(true);
    try {
      const json_res =
        JSON.parse(frequencyFilter).value === 3
          ? {
              startDate: fromDate,
              endDate: toDate,
            }
          : {};
      const { data } = await axiosInstance.post(
        searchAPI.userAnalytics,
        {
          ...json_res,
          frequencyFilter: JSON.parse(frequencyFilter).value,
          metricFilter: JSON.parse(metricFilter).value,
          userId: user.userId,
        },
        getConfig()
      );
      setSortVal(sortOptions[0]);
      let maxMetricCount;
      if (JSON.parse(frequencyFilter).value === 3) {
        maxMetricCount = Math.max(...data.map((obj) => obj.metricCount_lng));
      } else {
        const filteredData = data.filter(
          (obj) => obj.metricProperty_chr !== "NA"
        );
        maxMetricCount = Math.max(
          ...filteredData.map((obj) => obj.metricCount_lng)
        );
      }

      setMaxVal(maxMetricCount);

      setAllData(data);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const setDate = () => {
    if (fromDate && toDate) {
      setFrequencyFilter(JSON.stringify(frequencies[3]));
    }
  };

  const handleOptionClick = (e) => {
    if (JSON.parse(e.target.value).value === 3) {
      setDatepicker(true);
    }
  };

  const handleNext = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevious = () => {
    setPage((prevPage) => prevPage - 1);
  };

  const sortData = (option) => {
    let data = {};
    if (option.key >= 2) {
      if (option.key === 2)
        data = allData.sort((a, b) => b.metricCount_lng - a.metricCount_lng);
      else data = allData.sort((a, b) => a.metricCount_lng - b.metricCount_lng);
    } else {
      if (option.key === 0) {
        data = allData.sort((a, b) =>
          a.metricProperty_chr.localeCompare(b.metricProperty_chr)
        );
      } else
        data = allData.sort((a, b) =>
          b.metricProperty_chr.localeCompare(a.metricProperty_chr)
        );
    }

    const start = (page - 1) * ITEMS_PER_PAGE;
    const end = page * ITEMS_PER_PAGE;

    const sortedData = data.slice(start, end);
    setAnalyticsData(data);

    setLabels(sortedData.map((item) => item.metricProperty_chr));
    setMetricCounts(sortedData.map((item) => item.metricCount_lng));
    setAllData(data);
  };

  useEffect(() => {
    getData();
  }, [metricFilter, fromDate, toDate, frequencyFilter]);

  useEffect(() => {
    const start = (page - 1) * ITEMS_PER_PAGE;
    const end = page * ITEMS_PER_PAGE;

    const sortedData = allData.slice(start, end);
    setAnalyticsData(sortedData);

    let label = sortedData.map((item) => item.metricProperty_chr);
    let metricount = sortedData.map((item) => item.metricCount_lng);
    setUnratedMetric(0);

    if (JSON.parse(metricFilter).value === 3 && label.length > 0) {
      setUnratedMetric(metricount[metricount.length - 1]);
      label.pop();
      metricount.pop();
    }

    setLabels(label);
    setMetricCounts(metricount);
  }, [page, allData, metricFilter]);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    showInfoDietPopup && (
      <div className="popup-info-diet-container">
        <div className="bg-dark" />
        {!isMobile ? (
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            cancel={isMobile ? ".popup-info-diet" : null}
          >
            <div
              //   ref={divRef}
              //   onKeyDown={(e) => handleKeyDown(e)}
              className="popup-info-diet"
            >
              <div className="popup-card">
                <CloseIcon
                  className="cross"
                  onClick={() => setShowInfoDietPopup(false)}
                />
                {loading ? (
                  <div className="container">
                    <CustomLoader height="50vh" />
                  </div>
                ) : (
                  <div className="container">
                    {analyticsData.length ? (
                      <BarChartComponent
                        data={analyticsData}
                        labels={labels}
                        metricCounts={metricCounts}
                        metricFilter={metricFilter}
                        sortData={sortData}
                        sort={sort}
                        setSort={setSort}
                        unratedMetric={unratedMetric}
                        maxMetricCount={maxVal}
                        sortVal={sortVal}
                        setSortVal={setSortVal}
                      />
                    ) : (
                      <div className="bar-flex">
                        <p className="info">No Data to Show</p>
                      </div>
                    )}
                    {allData.length >= ITEMS_PER_PAGE && ( // Conditionally render the page labels
                      <>
                        {allData.length / ITEMS_PER_PAGE + 1 >= page && (
                          <div className="icon-right" onClick={handleNext}>
                            <div className="arrow-icon">
                              {" "}
                              <ArrowForwardIcon />
                            </div>
                          </div>
                        )}
                        {page > 1 && (
                          <div className="icon-left" onClick={handlePrevious}>
                            <div className="arrow-icon">
                              {" "}
                              <ArrowBackIcon />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div
                      className={`param-filter ${
                        JSON.parse(metricFilter).value !== 0 ? "minus-top" : ""
                      }`}
                    >
                      <div className="flex">
                        <p className="mr-2">Metric:</p>
                        <MenuPrimary
                          data={metrics.map((metric) => ({
                            ...metric,
                            onClick: () => {
                              setMetricFilter(JSON.stringify(metric));
                              setPage(1);
                            },
                          }))}
                          children={
                            <div className="flex">
                              <p>{JSON.parse(metricFilter).name}</p>
                              {}
                              <KeyboardArrowDownOutlinedIcon />
                            </div>
                          }
                        />
                      </div>
                      <div className="flex">
                        <p className="mr-2">Frequency:</p>

                        <MenuPrimary
                          data={frequencies.map((frequency) => ({
                            ...frequency,
                            onClick: () => {
                              if (frequency.value === 3) {
                                setDatepicker(true);
                              } else {
                                setFrequencyFilter(JSON.stringify(frequency));
                                setPage(1);
                              }
                            },
                          }))}
                          children={
                            <div className="flex">
                              <p>{JSON.parse(frequencyFilter).name}</p>
                              {}
                              <KeyboardArrowDownOutlinedIcon />
                            </div>
                          }
                        />
                      </div>
                    </div>
                    <p className="mt-2 message">
                      * Changes to your info diet may take 24 hours to appear *
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Draggable>
        ) : (
          <div
            //   ref={divRef}
            //   onKeyDown={(e) => handleKeyDown(e)}
            className="popup-info-diet"
          >
            <div className="popup-card">
              <CloseIcon
                className="cross"
                onClick={() => setShowInfoDietPopup(false)}
              />
              {loading ? (
                <div className="container">
                  <CustomLoader height="50vh" />
                </div>
              ) : (
                <div className="container">
                  {analyticsData.length ? (
                    <BarChartComponent
                      data={analyticsData}
                      labels={labels}
                      metricCounts={metricCounts}
                      metricFilter={metricFilter}
                      sortData={sortData}
                      sort={sort}
                      setSort={setSort}
                      unratedMetric={unratedMetric}
                      maxMetricCount={maxVal}
                      sortVal={sortVal}
                      setSortVal={setSortVal}
                    />
                  ) : (
                    <div className="bar-flex">
                      <p className="info">No Data to Show</p>
                    </div>
                  )}
                  {allData.length >= ITEMS_PER_PAGE && ( // Conditionally render the page labels
                    <>
                      {allData.length / ITEMS_PER_PAGE + 1 >= page && (
                        <div className="icon-right" onClick={handleNext}>
                          <div className="arrow-icon">
                            {" "}
                            <ArrowForwardIcon />
                          </div>
                        </div>
                      )}
                      {page > 1 && (
                        <div className="icon-left" onClick={handlePrevious}>
                          <div className="arrow-icon">
                            {" "}
                            <ArrowBackIcon />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div
                    className={`param-filter ${
                      JSON.parse(metricFilter).value !== 0 ? "minus-top" : ""
                    }`}
                  >
                    <div className="flex">
                      <p className="mr-2">Metric:</p>
                      <MenuPrimary
                        data={metrics.map((metric) => ({
                          ...metric,
                          onClick: () => {
                            setMetricFilter(JSON.stringify(metric));
                            setPage(1);
                          },
                        }))}
                        children={
                          <div className="flex">
                            <p>{JSON.parse(metricFilter).name}</p>
                            {}
                            <KeyboardArrowDownOutlinedIcon />
                          </div>
                        }
                      />
                    </div>
                    <div className="flex">
                      <p className="mr-2">Frequency:</p>

                      <MenuPrimary
                        data={frequencies.map((frequency) => ({
                          ...frequency,
                          onClick: () => {
                            if (frequency.value === 3) {
                              setDatepicker(true);
                            } else {
                              setFrequencyFilter(JSON.stringify(frequency));
                              setPage(1);
                            }
                          },
                        }))}
                        children={
                          <div className="flex">
                            <p>{JSON.parse(frequencyFilter).name}</p>
                            {}
                            <KeyboardArrowDownOutlinedIcon />
                          </div>
                        }
                      />
                    </div>
                  </div>
                  <p className="mt-2 message">
                    * Changes to your info diet may take 24 hours to appear *
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
        {datepicker && (
          <DateComponent
            setCalendarPopup={setDatepicker}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            requiredDates={2}
            setDate={setDate}
          />
        )}
      </div>
    )
  );
};

export default PopupInfoDiet;
